"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Trophy, Globe, Award } from "lucide-react";
const statistics = [{
  value: "1,2 mln €",
  label: "Wygenerowane dla",
  description: "klientów BH Marketing w kampaniach płatnych",
  icon: Award
}, {
  value: "100%",
  label: "Satysfakcji klienta",
  description: "oceniane przez każdego klienta BH Marketing",
  icon: Trophy
}, {
  value: "100,000€+",
  label: "Wygenerowane organicznie",
  description: "prowadząc kanały społecznościowe naszych klientów",
  icon: Globe
}];
export default function KeyStatisticsSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="key-statistics-section" className="py-12 md:py-16 bg-background overflow-hidden">
      <div className="container mx-auto px-6 md:px-8">
        <div className="max-w-3xl mb-8">
          <h2 className="text-sm font-mono font-semibold tracking-widest text-primary uppercase mb-4">NASZ WPŁYW</h2>
          <h3 className="text-4xl md:text-5xl font-sans font-bold tracking-tight text-foreground">Efekty, które mówią&nbsp;<span className="text-primary" data-ast-id="f:/src/pages/Homepage/sections/KeyStatisticsSection.tsx|sig:p8yc2l" data-ast-start="1251" data-ast-end="1305">same za siebie.</span></h3>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {statistics.map((stat, i) => <div key={i} data-index={i} style={{
          transitionDelay: `${i * 150}ms`
        }} className={`group relative p-8 md:p-10 bg-card border border-border rounded-2xl shadow-sm hover:shadow-md transition-all duration-700 ease-out flex flex-col items-start ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <div className="mb-6 p-3 bg-primary/5 rounded-lg text-primary group-hover:scale-110 transition-transform duration-300">
                <stat.icon size={32} strokeWidth={2} />
              </div>
              
              <div className="flex flex-col gap-2">
                <span className="text-5xl md:text-6xl font-sans font-bold tracking-tighter text-foreground">
                  {stat.value}
                </span>
                <span className="text-xl font-sans font-semibold text-foreground">
                  {stat.label}
                </span>
                <p className="text-muted-foreground font-sans leading-relaxed mt-2">
                  {stat.description}
                </p>
              </div>

              <div className="absolute bottom-0 left-8 right-8 h-1 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left rounded-t-lg" />
            </div>)}
        </div>
      </div>
    </section>;
}